import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";
import VueCircle from "vue2-circle-progress";

import { thumbnail, placeholderThumb } from "../../../functions/thumbnail";
import i18n from "../../../functions/i18next";

export default {
  props: {
    itemData: Object,
  },

  components: { VueCircle },
  /*
      Defines the data used by the component
    */
  data() {
    return {
      file: "",
      uploadPercentage: 0,
      step: 1,
      submitted: false,
      uploadComplete: false,
      update: 0,
      object: [],
      folder: 0,
      company: this.$store.state.company,
      mySpace: 0,
    };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.update = this.itemData.id;
      this.mySpace = this.itemData.myspace;
      this.object = this.itemData;
    },
    thumb(item) {
      return thumbnail(item);
    },
    onError() {
      return placeholderThumb();
    },
    saveFiles() {
      this.step = 2;
    },
    submitFiles() {
      if (!this.submitted) {
        this.submitted = true;
        let formData = new FormData();

        formData.append("file", this.file);
        formData.append("filetoupdate", this.update);
        formData.append("myspace", this.mySpace);

        localStorage.setItem("uploading", true);
        if (this.step == 2 && !this.uploadComplete) {
          // th
          let outer = this;
          this.step = 2;
          this.$axios
            .post(baseUrl + "/fileupdate", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              onUploadProgress: function (progressEvent) {
                if (
                  this.uploadPercentage <
                  parseInt(
                    Math.round(
                      (progressEvent.loaded * 100) / progressEvent.total
                    )
                  )
                ) {
                  this.uploadPercentage = parseInt(
                    Math.round(
                      (progressEvent.loaded * 100) / progressEvent.total
                    )
                  );
                  this.$refs.completedCircle.updateProgress(
                    this.uploadPercentage
                  );
                  if (this.uploadPercentage >= 100) {
                    this.uploadComplete = true;
                    // this.step = 3;

                    // NOW -> Processing: do some code
                  }
                }
              }.bind(this),
            })
            .catch(function (error) {
              if (error.response) {
                if (error.response.status == 402) {
                  alert(i18n.t("upload.upload_limit_reached"));
                  outer.show = false;
                }
              }
            })
            .then((response) => {
              localStorage.setItem("uploading", false);
              EventBus.$emit("openfolder", this.folder);
              this.file = "";
              // // this.show=false;
              this.uploadComplete = false;
              this.uploadPercentage = 0;
              this.submitted = false;
            });
        }
      }
    },
    fileName(ext) {
      let file = this.file;
      let extention =
        "." + file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2);
      if (ext) {
        return extention;
      }
      return file.name.replace(extention, "");
    },
    /*
          Removes a select file the user has uploaded
        */
    removeFile() {
      this.file = "";
    },

    processFile(event) {
      // this.files = this.$refs.files.files;
      this.file = event.target.files[0];
    },
    transitionHandler() {
      this.submitFiles();
    },
  },
};
